module.exports = __webpack_public_path__ + "static/media/login-right.0c160cf1.png";